import React, { useState, useEffect } from 'react';
import './empStyle.css';
import { Link, useParams, useNavigate } from 'react-router-dom';
import config from '../../config.json';

const apiUrl = config.apiUrl;

const EmpUpdate = () => {
    const [employeeData, setEmployeeData] = useState({
        IDNumber: '',
        LastName: '',
        FirstName: '',
        MiddleInitial: '',
        Position: '',
        UserID: '',
        Email: '',
    });

    const { employeeId } = useParams();
    const [userList, setUserList] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchEmployeeData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Employee/${employeeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                if (!response.ok) {
                    if (response.status === 401) {
                        // Redirect to login page if unauthorized
                        window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                    } else {
                        setErrorMessage('Failed to fetch data');
                        setSuccessMessage('');
                        return;
                    }
                }

                setEmployeeData({
                    IDNumber: data.Details.IdNumber,
                    LastName: data.Details.LastName,
                    FirstName: data.Details.FirstName,
                    MiddleInitial: data.Details.MiddleInitial,
                    Position: data.Details.Position,
                    UserID: data.Details.User.UserID,
                    Email: data.Details.User.Email,
                });

            } catch (error) {
                setErrorMessage('Error fetching employee data');
                setSuccessMessage('');
            }
        };

        const fetchUserData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/User`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                if (!response.ok) {
                    if (response.status === 401) {
                        // Redirect to login page if unauthorized
                        window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                    } else {
                        setErrorMessage('Failed to fetch data');
                        setSuccessMessage('');
                        return;
                    }
                }

                setUserList(data.User);

            } catch (error) {
                setErrorMessage('Failed fetching users data');
                setSuccessMessage('');
            }
        };

        if (employeeId) {
            fetchEmployeeData();
            fetchUserData();
        }
    }, [employeeId]);

    const handleInputChange = (e) => {
        setEmployeeData({ ...employeeData, [e.target.name]: e.target.value });
    };

    const handleForUpdate = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Employee/Update/${employeeId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(employeeData),
            });

            const data = await response.json();
            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    setErrorMessage(data.Message);
                    setSuccessMessage('');
                    return
                }
            }

            setSuccessMessage(data.Message);
            setErrorMessage('');

            navigate('/employee-list');
        } catch (error) {
            setErrorMessage('Error updating employee');
            setSuccessMessage('');
        }
    };

    const {
        IDNumber,
        LastName,
        FirstName,
        MiddleInitial,
        Position,
        UserID,
        Email,
    } = employeeData;

    return (
        <div>
            {userAccess.hasAdmin ? (
                <>
                    <h3>Update Employee</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleForUpdate}>
                        <div className='mb-3'>
                            <label htmlFor='idNumber' className='form-label'>ID Number</label>
                            <input
                                type="text"
                                className="form-control custom-width"
                                id="idNumber"
                                name="IDNumber"
                                value={IDNumber}
                                readOnly={true}
                            />
                        </div>
                        <div className='mb-3'>
                            <label htmlFor='lastName' className='form-label'>Last Name</label>
                            <input
                                type="text"
                                className="form-control custom-width"
                                id="lastName"
                                name="LastName"
                                value={LastName}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className='mb-3'>
                            <label htmlFor='firstName' className='form-label'>First Name</label>
                            <input
                                type="text"
                                className="form-control custom-width"
                                id="firstName"
                                name="FirstName"
                                value={FirstName}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="middleName" className="form-label">Middle Name</label>
                            <input
                                type="text"
                                className="form-control custom-width"
                                id="middleName"
                                name="MiddleInitial"
                                value={MiddleInitial}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="position" className="form-label">
                                Position
                            </label>
                            <input
                                type="text"
                                className="form-control custom-width"
                                id="position"
                                name="Position"
                                value={Position}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className='mb-3'>
                            <label htmlFor='userId' className='form-label'>User</label>
                            <select
                                type="text"
                                className="form-control custom-width"
                                id="userId"
                                name="UserID"
                                value={UserID}
                                onChange={handleInputChange}
                                required
                            >
                                <option key={UserID} value={Email}>{Email}</option>
                                {userList.map((user) => (
                                    <option key={user.UserID} value={user.UserID}>
                                        {`${user.Email}`}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Link to="/employee-list" className="btn btn-secondary me-2">Back</Link>
                        {(userAccess.hasStandard || userAccess.hasAdmin) && (
                            <button type="submit" className="btn btn-primary">Save</button>
                        )}
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    )
}

export default EmpUpdate;